import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ParticipantsItemCollapseFields } from './ParticipantsItemCollapse.enums';
import useParticipantsItemCollapse from './ParticipantsItemCollapse.hook';
import * as styles from './ParticipantsItemCollapse.styles';
import { ParticipantsItemCollapseProps } from './ParticipantsItemCollapse.types';
import FieldCard from 'components/FieldCard';
import FieldCardTitle from 'components/FieldCardTitle';
import CopyCard from 'modules/events/components/EventsList/LinkDialog/CopyCard';
import Collapse from 'yoda-ui/Collapse';
import Grid from 'yoda-ui/Grid';
import { YodaSpacing } from 'yoda-ui/yodaTheme';

const ParticipantsItemCollapse: FC<ParticipantsItemCollapseProps> = (props) => {
  const { t } = useTranslation();
  const { opened, ...participantData } = props;

  const { fieldsConfig } = useParticipantsItemCollapse(participantData);

  const fields = useMemo(
    () => fieldsConfig.map((field) => (
      <Grid item xs={ 12 } md={ 4 } key={ field.key }>
        <FieldCardTitle title={ field.label }/>
        {
          field.key === ParticipantsItemCollapseFields.zoomCallLink
            ? field.value && <CopyCard link={ field.value }/>
            : <FieldCard empty={ !field.value }>
              { field.value || t('person_field_notAvailable_label') }
            </FieldCard>
        }
      </Grid>
    )),
    [fieldsConfig, t],
  );

  return (
    <Collapse in={ opened } sx={ styles.Collapse }>
      <Grid
        container
        paddingTop={ YodaSpacing.medium }
        paddingRight={ YodaSpacing.small }
        paddingLeft={ YodaSpacing.small }
        paddingBottom={ YodaSpacing.small }
        rowGap={ YodaSpacing.none }
        spacing={ YodaSpacing.medium }
      >
        { fields }
      </Grid>
    </Collapse>
  );
};

export default ParticipantsItemCollapse;
